import { Component } from '@angular/core';
import { FooterConstants } from '@constants/constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  footerConstants = FooterConstants;
  currentYear: number = new Date().getFullYear();
}

